import { FormEvent, useEffect, useState } from 'react';
import { IListItem } from '@nkr/models/index';
import { HardBlockReason } from '@nkr/enums/hard-block-reason';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    alias: string,
    centerAlias: string,
    riskPercent: number,
    onDeclineDonor: () => void,
    onCancel: () => void
}

const HardBlock = (props: IProps) => {
    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Decline Donor {props.alias} from {props.centerAlias}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Alert bsStyle='danger'>
                        {`By declining this potential donor for your patient, it is possible the patient may not receive a match
                        offer for some time. The one year mortality risk for this patient is `}
                        <strong>{props.riskPercent}</strong>{`%`}
                </Alert>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onDeclineDonor}>Decline Donor</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default HardBlock;